module.exports = __webpack_public_path__ + "static/img/up-arrow.2c8f6bd5.png";